import { useAuth0 } from '@auth0/auth0-vue'
import { useGeneralStore } from '../general'
import { Auth } from '@utils/Auth'
import { handleError } from '@utils/helpers'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import actions from './actions'
import { useUserStore } from '../users'
import {useAssetStore} from '@stores/assets'
import ax from '@utils/axios'

export const getDefaultState = () => {
  return {
    permissions: ref(['VENDOR_ONLY', 'PARTNER_ONLY']),
    errors: ref({
      loginError: false,
      connectionError: false,
    }),
  }
}

export const useAuthStore = defineStore('auth', () => {
  const { clientOptions, isAuthenticated, getAccessTokenSilently, logout, loginWithRedirect } = useAuth0()
  function $reset() {
    Object.assign(this, getDefaultState())
  }

  function routeToLogin() {
    return loginWithRedirect({
      appState: {
        // TODO: use path from auth0.clientOptions.redirect_uri?
        target: '/spa/auth0-callback',
      },
    })
  }

  async function logIn() {
    if ( isAuthenticated ) {
      await ensureAccessToken()
      // fetchme handles the identify etc. now that it's removed from flask
      const userStore = useUserStore()

      // Setup Hubspot Analytics
      try {
        window._hsq.push(['identify', {
          email: userStore.user.email
        }])
        
      } catch (error) {
        console.log(error)
      }
      return true
    }
  }

  async function ensureAccessToken() {
    // TODO: adjust api eventually
    Auth.accessToken = { token: await getAccessTokenSilently() }
  }

  async function logOut() {
    const userStore = useUserStore()
    const generalStore = useGeneralStore()
    const assetStore = useAssetStore()
    generalStore.showLocalLoadingIndicator = true
  
    try {
      Auth.logout()
      this.$reset()
      userStore.$reset()
      assetStore.$reset()
      window.localStorage.clear() // clear all persisted local storage including cached pinia store
      logout({
        clientId: clientOptions.client_id,
        logoutParams: {
          returnTo: import.meta.env.VITE_LOGOUT_CALLBACK_URI
        }
      })
    }
    catch(error) {
      handleError(error)
    }
  }
  async function resetPassword() {
    const userStore = useUserStore()
    let payload = {
      'client_id': clientOptions.client_id,
      'email': userStore.user.email,
      'connection': 'Username-Password-Authentication'      
    }
  
    try {
      const url = `https://${clientOptions.domain}/dbconnections/change_password`
      await ax.post(url, payload)
    } catch (error) {
      handleError(error)
    }
  }
  return {
    ...getDefaultState(),
    ensureAccessToken,
    getDefaultState,
    ...actions,
    $reset,
    routeToLogin,
    logIn,
    logOut,
    resetPassword
  }
})
